import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SendTestEmailModule} from '../emailTest/send-test-email.module';
import { CreateEmailComponent } from './create-email.component';
import { ContentPreviewModule} from '../emailPreview/content-preview.module';
import { MaterialChipsInputModule } from '../tags/materialChipsInput.module';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import {FileUploadModule} from 'ng2-file-upload';
import { NgxSelectModule } from 'ngx-select-ex';
import {TranslatePipeModule} from '../../translate/translate.pipe.module';
import {ControlMessageModule} from '../../control-message/control-message.module';
import {GenericModalModule} from '../../modal/generic-modal.module';
@NgModule({
    imports: [
        CommonModule, MaterialChipsInputModule, FormsModule, ReactiveFormsModule, NgxSelectModule, TranslatePipeModule, FileUploadModule, ControlMessageModule, GenericModalModule
    ],
  declarations: [CreateEmailComponent],
  providers: [],
  exports: [CreateEmailComponent]
})
export class EmailModule {

}
